import axios from 'axios'

export function signin(email, password) {
  return axios.post(`${process.env.REACT_APP_HOST}/authenticate`, {
    email,
    password
  })
}
